var $93a763ccee88bbd5$exports = {};
$93a763ccee88bbd5$exports = {
    "actions": `Darb\u{12B}bas`,
    "hideButtonLabel": `R\u{101}d\u{12B}t maz\u{101}k`,
    "noTags": `Nav`,
    "showAllButtonLabel": (args, formatter)=>`R\u{101}d\u{12B}t visu (${formatter.number(args.tagCount)})`
};


export {$93a763ccee88bbd5$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
